import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_COACHING: TStep[] = [
  {
    pageId: PageId.DOG_SELECTOR,
  },
  {
    pageId: PageId.PROBLEM_DESCRIPTION,
  },
  {
    pageId: PageId.DOG_BREED_COACHING,
  },
  {
    pageId: PageId.DOG_AGE_COACHING,
  },
  {
    pageId: PageId.DOG_PROFILE_COACHING,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_COACHING,
  },
  {
    pageId: PageId.CANCEL_OFFER_COACHING,
  },
  {
    pageId: PageId.CALENDLY_COACHING,
  },
  {
    pageId: PageId.ALL_SET_COACHING,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_COACHING.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_COACHING.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
